import { RadixDialog } from '@/components/RadixDialog';
import { useGrantAccessPopupCopy } from '../../hooks';
import { DialogAction } from './GrantAccessDialogContent.styles';

interface GrantAccessDialogContentProps {
  onContinue: () => void;
}

// Only mounted while the dialog is open (Radix portal), so Statsig logs exposures for users who actually see it
export const GrantAccessDialogContent: React.FC<GrantAccessDialogContentProps> = ({ onContinue }) => {
  const { mainText, subText, cta } = useGrantAccessPopupCopy();

  return (
    <RadixDialog.Content>
      <RadixDialog.MainText>{mainText}</RadixDialog.MainText>
      <RadixDialog.SubText>{subText}</RadixDialog.SubText>
      <RadixDialog.Close asChild>
        <DialogAction onClick={onContinue}>{cta}</DialogAction>
      </RadixDialog.Close>
    </RadixDialog.Content>
  );
};
